var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"unique-opened":true,"default-openeds":[_vm.menu[0]?.id]},on:{"select":_vm.onSelect}},[_vm._l((_vm.menu),function(item){return [_c('SubMenu',{key:item.id,attrs:{"data":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }